<div *ngIf="!hasProject" class="card">
	<nz-alert
		nzType="warning" nzShowIcon
		nzMessage="{{ 'message.warning.project.noneLoaded.title' | translate }}"
		nzDescription="{{ 'message.warning.project.noneLoaded.description' | translate }}"
	></nz-alert>
</div>
<div *ngIf="privacyMode" class="card">
	<nz-alert *ngIf="privacyMode"
		nzType="warning" nzShowIcon
		nzMessage="{{ 'message.warning.privacy_protection.title' | translate }}"
		nzDescription="{{ 'message.warning.privacy_protection.description' | translate }}"
	></nz-alert>
</div>

<nz-card>
	<div class="toolbar">
		<app-search [autofocus]="autofocusTableSearch" (searchResults)="updateSearchResults($event)"
			(isLoading)="updateTableIsLoadingStatus($event)"></app-search>
		<div class="actions">
			<app-select-exports-button [listOfSelectedParticipants]="setOfCheckedId" [exportConfigs]="configs"
				sourceWindow="participantOverview" [totalNumberOfParticipants]="listOfDisplayData.length">
			</app-select-exports-button>
			<app-splitbutton *ngIf="hasProject && hasParticipantsCreatePermission" [elements]="[participantAddSplitButton]">
			</app-splitbutton>
		</div>
	</div>
	<nz-table #dynamicTable [nzData]="listOfData" [nzBordered]="bordered"
		[nzSimple]="simple" [nzLoading]="loading" [nzPaginationPosition]="position" [nzShowSizeChanger]="sizeChanger"
		[nzFrontPagination]="pagination" [nzShowPagination]="pagination" [nzPageSize]="25"
		[nzSize]="size" (nzCurrentPageDataChange)="currentPageDataChange($event)"
		class="kit__utils__table" style="overflow-x: hidden"
	>
		<thead>
		<tr *ngIf="header">
			<th [nzChecked]="checked" [nzIndeterminate]="indeterminate" (nzCheckedChange)="onAllChecked($event)"></th>
			<th nzCustomFilter
				[nzSortFn]="compareUid"
			>
				{{ 'user.uid' | translate}}
				<nz-filter-trigger [(nzVisible)]="uidFilterVisible" [nzActive]="uidFilterValue.length > 0" [nzDropdownMenu]="menuUid">
					<i nz-icon nzType="filter"></i>
				</nz-filter-trigger>

				<nz-dropdown-menu #menuUid="nzDropdownMenu">
					<div class="ant-table-filter-dropdown">
						<div class="search-box">
							<input type="text" nz-input [(ngModel)]="uidFilterValue" placeholder="{{ 'actions.searchFor' | translate :
							{searchItem : 'user.uid' | translate } }}" (ngModelChange)="filterUid()"/>
						</div>
					</div>
				</nz-dropdown-menu>
			</th>
			<th *ngFor="let column of dynamicColumns"
				nzCustomFilter
				nzWidth="{{column.width}}"
				[nzSortFn]="column.sortFn"
			>
				{{column.header | translate}}
				<nz-filter-trigger [(nzVisible)]="column.filterVisible" [nzActive]="column.filterSearchValue.length > 0" [nzDropdownMenu]="menu">
					<i nz-icon nzType="filter"></i>
				</nz-filter-trigger>

				<nz-dropdown-menu #menu="nzDropdownMenu">
					<div class="ant-table-filter-dropdown">
						<div class="search-box">
							<input type="text" nz-input [(ngModel)]="column.filterSearchValue" placeholder="{{ 'actions.searchFor' | translate :
							{searchItem : column.header | translate } }}" (ngModelChange)="filterSearch(column)"/>
						</div>
					</div>
				</nz-dropdown-menu>
			</th>
			<th nzCustomFilter
				[nzSortFn]="compareCreationTime"
			>
				{{ 'user.createdDate' | translate}}
				<nz-filter-trigger [(nzVisible)]="createdFilterVisible" [nzActive]="createdFilterValue.length > 0" [nzDropdownMenu]="menuCreated">
					<i nz-icon nzType="filter"></i>
				</nz-filter-trigger>

				<nz-dropdown-menu #menuCreated="nzDropdownMenu">
					<div class="ant-table-filter-dropdown">
						<div class="search-box">
							<input type="text" nz-input [(ngModel)]="createdFilterValue" placeholder="{{ 'actions.searchFor' | translate :
							{searchItem : 'user.createdDate' | translate } }}" (ngModelChange)="filterCreated()"/>
						</div>
					</div>
				</nz-dropdown-menu>
			</th>
		</tr>
		</thead>
		<tbody>
		<ng-template ngFor let-data [ngForOf]="dynamicTable.data">
			<tr (click)="showParticipantProfil(data)" [ngClass]="{'newestParticipant': data.newest}">
				<td
					[nzChecked]="setOfCheckedId.has(data.id)"
					[nzDisabled]="data.disabled"
					(nzCheckedChange)="onItemChecked(data.id, $event)"
				></td>
				<td>{{ data.id }}</td>
				<td *ngFor="let column of dynamicColumns">{{ column.interpolate(data) }}</td>
				<td>{{ data.formatDate }}</td>
			</tr>
		</ng-template>
		</tbody>
	</nz-table>
</nz-card>

<ng-template #customTplTooMany>
	<nz-empty nzNotFoundImage="simple" nzNotFoundContent="{{ 'search.too_many_results_more' | translate }}"></nz-empty>
</ng-template>
<ng-template #customTplEmpty>
	<nz-empty nzNotFoundImage="simple" nzNotFoundContent="{{ 'search.no_results' | translate }}"></nz-empty>
</ng-template>
